<template>
  <div class="box-father">
    <div v-if="!showTzDetail && !showShshDetail">
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">系统管理&nbsp;/&nbsp;</div>
          <div class="box-header-left-text">
            <div>用户管理&nbsp;/&nbsp;</div>
          </div>
          <div class="box-header-right" v-if="activeName == 'first'">
            <div>政务用户</div>
          </div>
          <div class="box-header-right" v-if="activeName == 'second'">
            <div>政务用户审核</div>
          </div>
          <div class="box-header-right" v-if="activeName == 'three'">
            <div>居民用户</div>
          </div>
          <div class="box-header-right" v-if="activeName == 'four'">
            <div>商户台账</div>
          </div>
          <div class="box-header-right" v-if="activeName == 'five'">
            <div>商户用户审核</div>
          </div>
          <div class="box-header-right" v-if="activeName == 'six'">
            <div>商户用户</div>
          </div>
          <div class="box-header-right" v-if="activeName == 'seven'">
            <div>建筑物台账</div>
          </div>
          <div class="box-header-right" v-if="activeName == 'notice'">
            <span>通知管理</span>
          </div>
          
        </div>
        <div class="box-header-notice-back" v-if="activeName == 'notice'">
          <el-button @click="goBackToShtz" class="back-btn">
            <img src="@/assets/image/back.png" alt=""> 返回
          </el-button>
        </div>
      </div>
      <div v-if="activeName != 'notice'" class="ledger">
        <el-tabs v-model="activeName">
          <el-tab-pane label="政务用户" name="first" v-if="btns.includes('zwList')">
            <zwList v-if="activeName == 'first'"></zwList>
          </el-tab-pane>
          <el-tab-pane label="政务用户审核" name="second" v-if="btns.includes('shList')">
            <shList v-if="activeName == 'second'"></shList>
          </el-tab-pane>
          <el-tab-pane label="居民用户" name="three" v-if="btns.includes('jmList')">
            <jmList v-if="activeName == 'three'"></jmList>
          </el-tab-pane>
          <el-tab-pane label="商户台账" name="four" v-if="btns.includes('shtzList')">
            <shtzList v-if="activeName == 'four'" @showDetail="changeShowDetail" @goToNoticeManagement="goToNoticeManagement"></shtzList>
          </el-tab-pane>
          <el-tab-pane label="商户用户审核" name="five" v-if="btns.includes('shshList')">
            <shshList @showShShDetail="changeShShDetail" v-if="activeName == 'five'"></shshList>
          </el-tab-pane>
          <el-tab-pane label="商户用户" name="six" v-if="btns.includes('shyhList')">
            <shyhList v-if="activeName == 'six'"></shyhList>
          </el-tab-pane>
          <el-tab-pane label="建筑物台账" name="seven" v-if="btns.includes('jzwList')">
            <jzwList v-if="activeName == 'seven'"></jzwList>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 通知管理 -->
    <noticeManagement v-if="activeName == 'notice'" @goBack="goBackToShtz"></noticeManagement>
    <!-- 商户台账详情 -->
    <shtzDetail v-if="showTzDetail" :currentItem="formInline" @closeDialog="showTzDetail = false"></shtzDetail>
    <!-- 商户用户审核 -->
    <shshDetail v-if="showShshDetail" :currentItem="formInline" @closeDialog="showShshDetail = false"></shshDetail>
  </div>
</template>

<script>
import jzwList from "./jzwList.vue";
import zwList from "./zwList.vue";
import jmList from "./jmList.vue";
import shList from "./shList.vue";
import shtzList from "./shtzList.vue";
import shshList from "./shxtList.vue";
import shyhList from "./shyhList.vue";
import shtzDetail from './shtzDetail.vue';
import shshDetail from './shshDetail.vue';
import noticeManagement from './noticeManagement.vue';

export default {
  name: "index",
  components: {
    jzwList,
    zwList,
    jmList,
    shList,
    shtzList,
    shshList,
    shyhList,
    shtzDetail,
    shshDetail,
    noticeManagement
  },
  data() {
    return {
      activeName: "first",
      showTzDetail: false,
      showShshDetail: false,
      formInline: {},
      btns: [],
      activeNameObj: {
        "zwList": "first",
        "shList": "second",
        "jmList": "three",
        "shtzList": "four",
        "shshList": "five",
        "shyhList": "six",
        "jzwList": "seven",
      }
    };
  },
  mounted () {
    let menuChildren = JSON.parse(sessionStorage.getItem("menuChildren"));
    menuChildren.forEach(element => {
      if (element.data.menuCode == "system-manage") {
        element.children.forEach(item => {
          if (item.data.menuCode == "userManagement") {
            if (item.children && item.children.length) {
              this.btns = item.children.map(itm => itm.data.menuCode) || [];
            }
          }
        });
      }
    });
    console.log("this.btns");
    console.log(this.btns, "this.btns");
    if (this.btns.length) this.activeName = this.activeNameObj[this.btns[0]] || '';
  },
  methods: {
    // 商户台账详情
    changeShowDetail (e) {
      this.showTzDetail = true;
      this.formInline = e.item;
    },
    // 商户用户审核
    changeShShDetail (e) {
      this.showShshDetail = true;
      this.formInline = {
        ...e.item,
        formShId: e.item.formShId
      };
    },
    // 跳转到通知管理
    goToNoticeManagement() {
      this.activeName = 'notice';
    },
    // 返回商户台账
    goBackToShtz() {
      this.activeName = 'four';
    }
  }
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
.ledger {
  background: #fff;
  padding: 16px 20px;
  // height: calc(100% - 60px);
  .el-tabs {
    background: #fff;
  }
  /deep/ .el-tabs__item {
    font-size: 16px;
  }
}
.box-header{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box-header-left {
  display: flex;
  align-items: center;
}

.back-btn {
  font-family: MiSans;
  font-size: 16px;
  font-weight: 400;
  color: #494C4F;
  border: 1px solid #D9DCDE;
  background: transparent;
  padding: 10px 20px;
  /deep/ span{
    display: flex;
    align-items: center;
    img{
      width: 14px;
      margin-right: 7px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/userManagement/index.vue